/**
 * Style utilities for Tracking page
 * Centralizes style logic to reduce duplication and improve maintainability
 */

/**
 * Get tab button styles based on active state and theme
 */
export const getTabButtonStyles = (
  isActive: boolean,
  isDark: boolean
): React.CSSProperties => ({
  padding: '8px 16px',
  border: 'none',
  background: 'transparent',
  color: isActive
    ? (isDark ? '#f1f5f9' : '#0f172a')
    : (isDark ? '#94a3b8' : '#64748b'),
  borderBottom: isActive
    ? `2px solid ${isDark ? '#667eea' : '#667eea'}`
    : '2px solid transparent',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: isActive ? '600' : '400',
  transition: 'all 0.2s',
});

/**
 * Get refresh button styles
 */
export const getRefreshButtonStyles = (
  isLoading: boolean,
  isDark: boolean
): React.CSSProperties => ({
  position: 'absolute',
  top: '10px',
  right: '10px',
  zIndex: 500,
  padding: '8px 12px',
  border: 'none',
  background: isLoading
    ? (isDark ? '#475569' : '#cbd5e1')
    : (isDark ? '#1e293b' : '#ffffff'),
  borderRadius: '6px',
  cursor: isLoading ? 'not-allowed' : 'pointer',
  fontSize: '16px',
  fontWeight: '500',
  transition: 'all 0.2s',
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  opacity: isLoading ? 0.6 : 1,
});

/**
 * Get container border color based on theme
 */
export const getBorderColor = (isDark: boolean): string => 
  isDark ? '#334155' : '#e2e8f0';

